export interface TeaserHomeData {
  title: string;
  buttonText: string;
  imageSrc: string;
}
 
export const TEASER_HOME_DATA: TeaserHomeData = {
  title: "Smart Thinking, Bold Coding.",
  buttonText: "Explore",
  imageSrc: "/teaser.jpg"
}; 